import React, { Component } from 'react';
import styles from './styles.module.scss';

interface Props {
	text?: string;
}

export default class CreditCardsEmpty extends Component<Props> {
	render() {
		const { text } = this.props;
		return <div className={styles.noCard}>{text || 'No saved cards'}</div>;
	}
}
